import { addFormFields, removeFieldsById } from "../../../../../utils/FormFields/RemoveFields/handleRemoveFields";
import { HideShowRedirectionUrlConfig } from "./addHideShowFileds";

const handleFieldChange = (dataFieldName, updateFormData, AvailabilityScheduleData, setScheduleType) => {
    switch (dataFieldName) {
        case "isRedirection": {
            const { isRedirection } = updateFormData;
            if (isRedirection === "yes") {
                /**
               * @param {object} AvailabilityScheduleData - The form data object.
               * @param {Array<object>} HideShowSupportFileFieldConfig - Fields to add for file uploads.
               * @param {string} "relevantDiplomasCertificatesFile" - The ID after which the fields will be added.
               */
                debugger;
                addFormFields(AvailabilityScheduleData, HideShowRedirectionUrlConfig, "isRedirection");
            } else {
                /**
                 * @param {object} AvailabilityScheduleData - The form data object.
                 * @param {Array<string>} ['redirectionUrl'] - The IDs of fields to remove.
                 */
                removeFieldsById(AvailabilityScheduleData, ['redirectionUrl']);
            }
            break;
        }
        case "scheduleType": {
            const { scheduleType } = updateFormData;
            setScheduleType(scheduleType);
            break;
        }
        default:
            break;
    }
};

export default handleFieldChange;


